import  {DomesticShipment, type DomesticShipmentData} from "@/types/shipments/Domestic/DomesticShipment.ts";
import  {InternationalShipment, type InternationalShipmentData} from "@/types/shipments/International/InternationalShipment.ts";
import  {Invoice,type InvoiceData} from "@/types/invoices/Invoice";

export class InvoiceLine {
    public id: number | null;
    public invoice_id: number | null ;
    public perm_shipment_id: string ;
    public cost_code: string ;
    public cost_description: string ;
    public department_name: string ;
    public office_code: string ;
    public outgoing_amount: number | null ;
    public outgoing_currency_code: string ;
    public outgoing_invoice_line_quantity: number | null ;
    public outgoing_inv_line_base_code: string ;
    public outgoing_inv_line_vat_code: string ;
    public outgoing_inv_line_vat_percentage: string ;
    public outgoing_inv_line_vat_amount: string ;
    public domesticShipment : DomesticShipment|null;
    public internationalShipment : InternationalShipment|null;
    public invoice : Invoice|null;
    public createdAt: Date|null;

    constructor(data: InvoiceLineData | void) {
        if (data === undefined) {
            this.id = null;
            this.invoice_id = null;
            this.perm_shipment_id = "";
            this.cost_code = "";
            this.cost_description = "";
            this.department_name = "";
            this.office_code = "";
            this.outgoing_amount = null;
            this.outgoing_currency_code = "";
            this.outgoing_invoice_line_quantity = null;
            this.outgoing_inv_line_base_code = "";
            this.outgoing_inv_line_vat_code = "";
            this.outgoing_inv_line_vat_percentage = "";
            this.outgoing_inv_line_vat_amount = "";
            this.createdAt = null;
            this.domesticShipment = null;
            this.internationalShipment = null;
            this.invoice = null;

        } else {
            this.id = data.id;
            this.invoice_id = data.invoice_id;
            this.perm_shipment_id = data.perm_shipment_id;
            this.cost_code = data.cost_code;
            this.cost_description = data.cost_description;
            this.department_name = data.department_name;
            this.office_code = data.office_code;
            this.outgoing_amount = data.outgoing_amount;
            this.outgoing_currency_code = data.outgoing_currency_code;
            this.outgoing_invoice_line_quantity = data.outgoing_invoice_line_quantity;
            this.outgoing_inv_line_base_code = data.outgoing_inv_line_base_code;
            this.outgoing_inv_line_vat_code = data.outgoing_inv_line_vat_code;
            this.outgoing_inv_line_vat_percentage = data.outgoing_inv_line_vat_percentage;
            this.outgoing_inv_line_vat_amount = data.outgoing_inv_line_vat_amount;
            this.createdAt = data.createdAt;
            this.domesticShipment = null;
            if(data.domesticShipment !== null && data.domesticShipment !== undefined){
                this.domesticShipment = new DomesticShipment(data.domesticShipment);
            }
            this.internationalShipment = null;
            if(data.internationalShipment !== null && data.internationalShipment !== undefined){
                this.internationalShipment = new InternationalShipment(data.internationalShipment);
            }
            this.invoice = null;
            if(data.invoice !== null && data.invoice !== undefined){
                this.invoice = new Invoice(data.invoice);
            }
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.invoice_id = null;
        this.perm_shipment_id = "";
        this.cost_code = "";
        this.cost_description = "";
        this.department_name = "";
        this.office_code = "";
        this.outgoing_amount = null;
        this.outgoing_currency_code = "";
        this.outgoing_invoice_line_quantity = null;
        this.outgoing_inv_line_base_code = "";
        this.outgoing_inv_line_vat_code = "";
        this.outgoing_inv_line_vat_percentage = "";
        this.outgoing_inv_line_vat_amount = "";
        this.createdAt = null;
    }
    serializeData():InvoiceLineData {
        return {
            id: this.id,
            invoice_id: this.invoice_id,
            perm_shipment_id: this.perm_shipment_id,
            cost_code: this.cost_code,
            cost_description: this.cost_description,
            department_name: this.department_name,
            office_code: this.office_code,
            outgoing_amount: this.outgoing_amount,
            outgoing_currency_code: this.outgoing_currency_code,
            outgoing_invoice_line_quantity: this.outgoing_invoice_line_quantity,
            outgoing_inv_line_base_code: this.outgoing_inv_line_base_code,
            outgoing_inv_line_vat_code: this.outgoing_inv_line_vat_code,
            outgoing_inv_line_vat_percentage: this.outgoing_inv_line_vat_percentage,
            outgoing_inv_line_vat_amount: this.outgoing_inv_line_vat_amount,
            createdAt: this.createdAt,
            domesticShipment: this.domesticShipment,
            internationalShipment: this.internationalShipment,
            invoice: this.invoice,
        }
    }
}

export type InvoiceLineData = {
    id:number|null;
    invoice_id:number|null;
    perm_shipment_id:string;
    cost_code:string;
    cost_description:string;
    department_name:string;
    office_code:string;
    outgoing_amount:number|null;
    outgoing_currency_code:string;
    outgoing_invoice_line_quantity:number|null;
    outgoing_inv_line_base_code:string;
    outgoing_inv_line_vat_code:string;
    outgoing_inv_line_vat_percentage:string;
    outgoing_inv_line_vat_amount:string;
    createdAt:Date|null;
    domesticShipment : DomesticShipmentData|null|undefined;
    internationalShipment : InternationalShipmentData|null|undefined;
    invoice : InvoiceData|undefined|null;
}